import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { AttachmentDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { AttachmentDto } from 'src/app/shared/models/attachment/attachment-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class AttachmentWorkItem extends WorkItem<AttachmentDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'AttachmentWorkItem';
  }

  get database(): string {
    return AttachmentDB;
  }
}
